function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#ffda44"
}, /*#__PURE__*/React.createElement("path", {
  d: "M284.986 204.557c0-16.008-12.977-28.986-28.986-28.986-16.008 0-28.986 12.978-28.986 28.986h-63.768c0 15.761 13.729 28.538 29.49 28.538h-.949c0 15.762 12.777 28.541 28.54 28.541 0 13.955 10.023 25.551 23.259 28.031l-.075.167h24.977l-.073-.167c13.237-2.48 23.26-14.076 23.26-28.031 15.763 0 28.54-12.778 28.54-28.541h-.951c15.761 0 29.49-12.778 29.49-28.538h-63.768z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M243.258 286.877l-17.972 40.575A81.349 81.349 0 00256 333.449a81.355 81.355 0 0030.713-5.997l-17.971-40.575h-25.484z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M218.899 218.811v49.928c0 28.399 37.101 37.101 37.101 37.101s37.101-8.702 37.101-37.101v-49.928h-74.202z",
  fill: "#f0f0f0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M126.719 257.195l20.066 56.123 19.857-56.123h15.154l-28.95 74.203h-12.123l-29.158-74.203h15.154zm233.165 74.204v-74.203h14.423v74.203h-14.423z",
  fill: "#338af3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M233.739 234.935v60.503c5.101 3.753 10.588 6.337 14.84 7.989v-68.492h-14.84zm44.522 0v60.503c-5.101 3.753-10.588 6.337-14.84 7.989v-68.492h14.84z",
  fill: "#d80027"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M218.902 218.808h74.207v23.541h-74.207z"
});

const SvgVirginIslands = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVirginIslands, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/virgin-islands.9e05a041.svg";
export { ForwardRef as ReactComponent };